var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{attrs:{"rules":_vm.isItRequired,"label":_vm.generateLabel,"hint":_vm.field.hint,"disabled":_vm.isDisabled},on:{"change":_vm.handleCheckboxChange},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }